// src/utils/notify.js
export function requestNotifyPermission() {
    if (!('Notification' in window)) return;
    if (Notification.permission === 'default') {
        Notification.requestPermission();
    }
}

export function notify(title, body) {
    if (!('Notification' in window)) return;
    if (Notification.permission !== 'granted') return;
    try {
        new Notification(title, { body });
    } catch (e) {
        // Algunos navegadores requieren que se use Service Worker para persistencia,
        // pero para un aviso simple, esto funciona en la mayoría.
        console.warn('Notification error:', e);
    }
}
